import { env } from "@/lib/env";
import { useWorkspaces } from "@/features/workspaces/api";
import type { WorkspaceWithMembership } from "@bizy/core";

export interface DemoWorkspaceState {
  workspace: WorkspaceWithMembership | null;
  slug: string | null;
  items: readonly WorkspaceWithMembership[];
  isLoading: boolean;
  isError: boolean;
}

/**
 * Preview build (`main`): the dashboard CTA jumps straight into a workspace
 * instead of showing a selector. The slug comes from `VITE_PREVIEW_WORKSPACE_SLUG`
 * and falls back to the first workspace the API returns (the seeded demo tenant).
 */
export const useDemoWorkspace = (): DemoWorkspaceState => {
  const workspacesQuery = useWorkspaces();
  const items = workspacesQuery.data?.items ?? [];
  const preferred = env.previewWorkspaceSlug;
  const workspace = (preferred && items.find((item) => item.slug === preferred)) || items[0] || null;

  return {
    workspace,
    slug: workspace?.slug ?? null,
    items,
    isLoading: workspacesQuery.isLoading,
    isError: workspacesQuery.isError,
  };
};
